import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Reportes Ventas", icon: "fas fa-chart-line", color: "#10b981", bg: "#f0fdf4", href: "/MenuReportesVentas", desc: "Reportes de ventas",     perm: "menu_reportes" },
  { label: "Reportes Admin",  icon: "fas fa-dollar-sign", color: "#f59e0b", bg: "#fffbeb", href: "/MenuReportesAdmin",  desc: "Reportes administrativos", perm: "menu_reportes" },
  { label: "Dashboards",      icon: "fas fa-chart-bar",   color: "#6366f1", bg: "#eef2ff", href: "/Dashboards",         desc: "Paneles ejecutivos",      perm: "menu_reportes" },
];

function BotonesReportes() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-line" color="#10b981" bg="#f0fdf4" title="Reportes" subtitle="Análisis e indicadores" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            ))}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesReportes;
